<script>
export default {
  name: 'has-pagination',
  computed: {
    lsOptionsName () {
      let base = this.$options.name;

      if (this.subviewName) {
        return base + '-' + this.subviewName;
      }

      return base;
    }
  },
  data () {
    return {
      currentPage: 1,
      paginationMetaData: null
    };
  },
  beforeMount () {
    if (localStorage.getItem('headwear-crm-pagination') && !this.skipLSPagination) {
      let paginationData = JSON.parse(localStorage.getItem('headwear-crm-pagination'));

      if (paginationData.view && paginationData.view === this.lsOptionsName) {
        this.currentPage = paginationData.page;
      } else {
        localStorage.removeItem('headwear-crm-pagination');
      }
    }
  },
  mounted () {
    this.$bus.$on('pagination-page-changed', this.setPage);
    this.$bus.$on('pagination-reset', this.resetPagination);
  },
  methods: {
    setPage (page) {
      this.currentPage = page;

      if (!this.skipLSPagination) {
        localStorage.setItem('headwear-crm-pagination', JSON.stringify({
          view: this.lsOptionsName,
          page: this.currentPage
        }));
      }
      this.debouncedLoadFilteredData();
    },
    resetPagination () {
      this.currentPage = 1;

      if (!this.skipLSPagination) {
        localStorage.setItem('headwear-crm-pagination', JSON.stringify({
          view: this.lsOptionsName,
          page: 1
        }));
      }
      this.debouncedLoadFilteredData();
    }
  },
  beforeDestroy () {
    this.$bus.$off('pagination-page-changed', this.setPage);
    this.$bus.$off('pagination-reset', this.resetPagination);
  }
}
</script>
